import { useMemo, useState } from "react";
import DataTable from "components/DataTable/DataTable";
import Pod from "components/Pod/Pod";
import { Button } from "components/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import "./ContentCreationCourses.scss"
import { DataFetcher } from "../../../components/DataFetcher";

const STATUS_MAP = {
	0: "Unpublished Changes",
	1: "Published",
	2: "Hidden",
};

const ContentCreationCourses = () => {
	const [searchValue, setSearchValue] = useState("");
	const fetchData = { url: "/api/v3/Courses" };
	const [data, setData] = useState(null);

	const filtered = useMemo(() => {
		if (!data) {
			return [];
		}
		const query = searchValue.trim().toLocaleLowerCase();
		if (!query) {
			return data;
		}
		return data.filter((course) =>
			course.Name.toLowerCase().includes(query) ||
			(course.Offers?.some(offer => offer.toLowerCase().includes(query))) ||
			String(course.UserCount).includes(query) ||
			STATUS_MAP[course.CourseStatus]?.toLowerCase().includes(query)
		);
	}, [data, searchValue]);

	const statusTemplate = (row) => STATUS_MAP[row.CourseStatus] ?? "-";
	const usersTemplate = (row) => row.UserCount?.toLocaleString?.() ?? row.UserCount;
	const editTemplate = (row) => (
		<Button
			text="Edit"
			to={`/editcourse#courseId-${row.Id}`}
		/>
	);

	const columns = [
		{ field: "Name", headerName: "Course Name", valueGetter: (row) => row.Name, sortable: true },
		{
			field: "Offers",
			headerName: "Offers",
			valueGetter: (row) => {
				const offers = row.Offers?.join(", ") ?? "";
				return offers || <em>(No offers assigned)</em>;
			},
			sortable: true
		},
		{ field: "CourseStatus", headerName: "Status", valueGetter: statusTemplate, sortable: true },
		{ field: "UserCount", headerName: "Users Enrolled", valueGetter: usersTemplate, sortable: true },
		{ headerName: "Actions", valueGetter: editTemplate, sortable: false, removeHeaderFromMobile: true },
	];

	return (
		<DataFetcher fetchData={fetchData} setData={setData}>
			<div className="content-creation-courses gutters">
				<Pod title="All Courses">
					<div className="datatable-pod">
						<div className="datatable-pod-buttons">
							<div className="searchbox">
								<input
									className="searchbox-input"
									type="text"
									placeholder="Search courses"
									value={searchValue}
									onChange={(e) => setSearchValue(e.target.value)}
								/>
								<span className="searchbox-icon">
									<FontAwesomeIcon icon={faMagnifyingGlass} />
								</span>
							</div>
							<Button text="Add Course" onClick={() => console.log("Add Course")} />
						</div>

						<DataTable
							rows={filtered}
							columns={columns}
							rowsPerPage={10}
							useCardView={true}
							noSearchOnMobile={true}
						/>

						<div className="datatable-pod-buttons">
							<Button text="Add Course" onClick={() => console.log("Add Course")} />
						</div>
					</div>
				</Pod>
			</div>
		</DataFetcher>
	);
};

export default ContentCreationCourses;
